import React from 'react'
import { motion } from "motion/react"
import binSolyman from '../../../assets/images/binSolyman.jpg'

const container = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.15 },
  },
}

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
}

const fadeLeft = {
  hidden: { opacity: 0, x: 40 },
  show: { opacity: 1, x: 0, transition: { duration: 0.7, ease: 'easeOut' } },
}

const fadeRight = {
  hidden: { opacity: 0, x: -40 },
  show: { opacity: 1, x: 0, transition: { duration: 0.7, ease: 'easeOut' } },
}

const sectionReveal = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.6, ease: 'easeOut' },
  viewport: { once: true, amount: 0.2 },
}

export default function Royal() {
  return (
    <motion.section
      {...sectionReveal}
      variants={container}
      initial="hidden"
      whileInView="show"
      className="bg-black pt-16 pb-12 md:pb-0 flex flex-wrap flex-col-reverse md:flex-row items-center justify-between overflow-hidden"
    >
      <motion.div variants={fadeLeft} className='md:w-2/4 px-6 md:px-16 space-y-10'>
        <motion.p variants={fadeUp} className='text-white xl:text-4xl text-xl lg:text-3xl font-semibold leading-relaxed relative'>
          <span className="absolute -left-6 -top-4 w-16 h-16 rounded-full bg-white/5 blur-2xl" aria-hidden />
          <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 100 70"
              fill="currentColor"
              className='w-10 h-10 text-[#9ca3af]'
          >

          <path d="M10 10h30v30c0 15-10 20-20 25l-5-10c7-4 10-7 10-15H10V10z"/>
          <path d="M60 10h30v30c0 15-10 20-20 25l-5-10c7-4 10-7 10-15H60V10z"/>
          </svg>
            إن مستقبــل المملكة، أيها الإخوة والأخوات، مبشــر وواعد، بإذن الله
            ، و تستحق بلادنا الغالية أكثر مما تحقق. لدينا قدراتٌ سنقوم بمضاعفة دورها و زيادة إسهامها فى صناعة هذا المستقبل،
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 100 70"
                fill="currentColor"
                className='w-10 h-10 rotate-180 mr-auto text-[#9ca3af]'
              >
                <path d="M10 10h30v30c0 15-10 20-20 25l-5-10c7-4 10-7 10-15H10V10z"/>
                <path d="M60 10h30v30c0 15-10 20-20 25l-5-10c7-4 10-7 10-15H60V10z"/>
              </svg>
              </motion.p>

              <motion.p variants={fadeUp} className='text-[#DEDF9F] xl:text-4xl text-xl lg:text-3xl font-semibold leading-relaxed text-center'>
              صاحب السمو الملكي <br />
              الأمير محمد بن سلمان بن عبد العزيز آل سعود ولي العهد ، رئيس مجلس الوزراء ، ورئيس مجلس الشؤون الاقتصادية و التنمية
            </motion.p>
      </motion.div>
      <motion.div variants={fadeRight} className="md:w-2/4 flex justify-center md:justify-end px-6 md:px-0">
        <img src={binSolyman} alt="الأمير محمد بن سلمان" className="w-[80%] mr-auto h-full object-cover drop-shadow-[0_30px_80px_-45px_rgba(15,23,42,0.6)]" />
      </motion.div>
    </motion.section>
  )
}